import React from "react";
import { PageHeader } from "@/components/common/PageHeader";
import { useDashboard } from "@/hooks/useResource";
import { RevenueArea, ChannelBars, DonutChart, Funnel } from "@/components/common/Charts";
import { KpiCard } from "@/components/common/KpiCard";
import { Skeletons } from "@/components/common/EmptyState";
import { ChartBar } from "@phosphor-icons/react";

const ATTRIBUTION = [
  { model: "First-touch", instagram: 38, ads: 28, email: 14, influencer: 20 },
  { model: "Last-touch", instagram: 24, ads: 41, email: 19, influencer: 16 },
  { model: "Multi-touch", instagram: 31, ads: 34, email: 16, influencer: 19 },
];

export default function Analytics() {
  const { data, isLoading } = useDashboard();

  return (
    <div>
      <PageHeader title="Analytics & Attribution" subtitle="Follow every rupee across the customer journey" icon={ChartBar} />
      {isLoading || !data ? <Skeletons count={8} /> : (
        <>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {data.kpis.slice(0, 4).map((k, i) => <KpiCard key={k.label} {...k} delay={i * 0.04} />)}
          </div>
          <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-3">
            <div className="rounded-2xl border border-border bg-surface-raised p-6 lg:col-span-2"><h2 className="mb-4 font-display text-lg font-bold">Revenue Trend</h2><RevenueArea data={data.trend} /></div>
            <div className="rounded-2xl border border-border bg-surface-raised p-6"><h2 className="mb-4 font-display text-lg font-bold">Channel Mix</h2><DonutChart data={data.channel_revenue} /></div>
          </div>
          <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div className="rounded-2xl border border-border bg-surface-raised p-6"><h2 className="mb-4 font-display text-lg font-bold">Conversion Funnel</h2><Funnel data={data.funnel} /></div>
            <div className="rounded-2xl border border-border bg-surface-raised p-6"><h2 className="mb-4 font-display text-lg font-bold">Revenue by Channel</h2><ChannelBars data={data.channel_revenue} /></div>
          </div>
          <div className="mt-6 rounded-2xl border border-border bg-surface-raised p-6">
            <h2 className="mb-4 font-display text-lg font-bold">Attribution Model Comparison</h2>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead><tr className="border-b border-border text-left">{["Model", "Instagram", "Paid Ads", "Email", "Influencer"].map((h) => <th key={h} className="px-4 py-2 text-xs font-bold uppercase tracking-wider text-muted-foreground">{h}</th>)}</tr></thead>
                <tbody>
                  {ATTRIBUTION.map((r) => (
                    <tr key={r.model} className="border-b border-border/60">
                      <td className="px-4 py-3 font-medium">{r.model}</td>
                      {["instagram", "ads", "email", "influencer"].map((k) => <td key={k} className="px-4 py-3"><span className="font-mono">{r[k]}%</span></td>)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
